<template>
  <div>
    <h1 class="js_error_header">Error</h1>
    <span>An unexpected error occurred. Please try <a href="/">reloading</a> the website and contact support if the error persists.</span>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { removeLoadingScreen } from "@/plumbing/loadingScreen";
@Component
export default class Error extends Vue {
  mounted() {
    removeLoadingScreen();
  }
}
</script>
